import {Graphics, InteractionEvent, Sprite, Text} from 'pixi.js';
import {CardData} from '../../../../../../data/active_data/field_config/card_stack_data/CardData';
import {TextFactory} from '../../../../../../factories/TextFactory';
import {Pivot} from '../../../../../../utils/Pivot';
import {StackSelector} from '../../../../../../controllers/StackSelector';
import {ApiSendCommandsController} from '../../../../../../controllers/ApiSendCommandsController';
import {Stack} from '../Stack';

export class SimiloButton extends Sprite
{
    private back: Graphics;
    private text: Text;

    constructor(cardData: CardData, private stack: Stack) {
        super();
        const btnWidth: number = cardData.width;
        const btnHeight: number = 96;

        this.back = new Graphics();
        this.back.beginFill(0xF65A00);
        this.back.drawRoundedRect(0, 0, btnWidth, btnHeight, btnHeight / 8);
        this.back.endFill();
        this.addChild(this.back);

        this.text = TextFactory.create(cardData.flipped ? 'Cancel' : 'Remove', 48);
        this.text.x = btnWidth / 2;
        this.text.y = btnHeight / 2;
        Pivot.centerPivot(this.text);
        this.addChild(this.text);

        this.y = cardData.height - btnHeight;

        this.interactive = this.interactiveChildren = this.buttonMode = true;

        this.on('pointerup', this.onPointerUp, this);
        this.on('pointerdown', this.onPointerDown, this);
    }

    destroy(): void {
        this.off('pointerup', this.onPointerUp, this);
        this.off('pointerdown', this.onPointerDown, this);
    }

    private onPointerUp(e: InteractionEvent): void {
        StackSelector.unselectAll();
        ApiSendCommandsController.flipStacks([this.stack]);
        e.stopPropagation();
    }

    private onPointerDown(e: InteractionEvent): void {
        e.stopPropagation();
    }
}
